<template>
  <span class="status-badge inline-flex items-center gap-1" :class="meta.class">
    <span v-if="showDot" class="h-1.5 w-1.5 rounded-full bg-current opacity-70"></span>
    {{ meta.label }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { getBadgeMeta } from '../utils'

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number],
    default: ''
  },
  showDot: {
    type: Boolean,
    default: false
  }
})

const meta = computed(() => getBadgeMeta(props.type, props.value))
</script>
